import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from '../../core/auth/auth.service';
import { LoginSessionState, SessionTimerServiceService } from '../../core/auth/session-timer-service.service';

@Component({
  selector: 'hb-aside',
  templateUrl: './app-aside.component.html',
})
export class AppAsideComponent implements OnInit, OnDestroy {
  private unsubscribe: Subject<boolean> = new Subject();

  constructor(private el: ElementRef,
              private timeoutService: SessionTimerServiceService,
              private authService: AuthService) { }

  // wait for the component to render completely
  public ngOnInit(): void {
    this.timeoutService.loginSessionStateChanged.pipe(
      takeUntil(this.unsubscribe))
      .subscribe(state => {
        if (state === LoginSessionState.NotLoggedIn) {
          this.hide();
        }
      });

    this.authService.loggedIn.pipe(takeUntil(this.unsubscribe)).subscribe(loginState => {
      if (!loginState) {
        this.hide();
      }
    });

    const nativeElement: HTMLElement = this.el.nativeElement;
    const parentElement: HTMLElement = nativeElement.parentElement;
    // move all children out of the element
    while (nativeElement.firstChild) {
      parentElement.insertBefore(nativeElement.firstChild, nativeElement);
    }
    // remove the empty element(the host)
    parentElement.removeChild(nativeElement);
  }

  public ngOnDestroy(): void {
    this.unsubscribe.next(true);
    this.unsubscribe.complete();
  }

  /**
   * Uses direct JS DOM manipulation to:
   * - Hide the notifications sidebar
   * - Hide the tile controls
   * - Remove the margin set aside for toast notifications
   */
  private hide(): void {
    document.querySelector('body').classList.add('aside-menu-hidden');

    const listControl = document.getElementById('dynamic-fixed-list');
    if (listControl != null) {
      listControl.classList.remove('aside-showing');
    }

    document.getElementById('aside-menu').classList.remove('showing');
    document.getElementById('notification-toast').firstElementChild.classList.remove('toast-margin');
  }
}
